import { useState, useEffect } from 'react';

function useLoadFont(font) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (document.fonts.check(font)) {
      setLoaded(true);
      return;
    }
    document.fonts.load(font).then(() => {
      setLoaded(true);
    });
  }, [font]);
  return loaded;
}

export { useLoadFont };
//# sourceMappingURL=fonts-ready.js.map
